module.exports = __webpack_public_path__ + "static/homepage-headphones-sections-manager-3157b9e055bc4b3ef1c76801ae983318.png";